// The Studio's frame: a printed masthead over the work.
//
// Deliberately not the same shape as the admin cockpit -- no rail, no
// instruments, a wordmark set in a display serif, section links in small
// caps, and one line of account. Someone who uses both should never be in
// doubt about which one they are in.
import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { formatMinor } from "../../lib/format";
import { useCatalog } from "../../lib/catalog";
import { useTheme } from "./useTheme";

export default function UserShell() {
  const { user, signOut } = useAuth();
  const catalog = useCatalog(user?.user_id);
  useTheme("user");

  return (
    <div className="u-app">
      {user && (
        <header className="u-mast">
          <div className="u-mast__brand">
            <Link className="u-mast__word" to="/">
              gpu-fan
            </Link>
            <span className="u-mast__tag">Studio</span>
          </div>
          <nav className="u-mast__links">
            <NavLink to="/" end className={linkClass}>
              Generate
            </NavLink>
            <NavLink to="/tasks" className={linkClass}>
              Tasks
            </NavLink>
            <NavLink to="/library" className={linkClass}>
              Library
            </NavLink>
            {catalog?.features.prompt_ideas !== false && (
              <NavLink to="/prompt-ideas" className={linkClass}>
                Prompt ideas
              </NavLink>
            )}
            <NavLink to="/account" className={linkClass}>
              Account
            </NavLink>
          </nav>
          <div className="u-mast__account">
            <span className="u-mast__who">{user.email}</span>
            <span className="u-mast__balance">{formatMinor(user.balance, user.currency)}</span>
            {user.role === "ADMIN" && (
              <Link className="u-btn u-btn--quiet" to="/admin">
                Cockpit
              </Link>
            )}
            <button className="u-btn u-btn--quiet" onClick={() => void signOut()}>
              Sign out
            </button>
          </div>
        </header>
      )}
      <main className="u-main">
        <Outlet />
      </main>
    </div>
  );
}

function linkClass({ isActive }: { isActive: boolean }): string {
  return isActive ? "u-mast__link u-mast__link--on" : "u-mast__link";
}
